var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star Bullet",
    filter: "url(#filter0_di_348_8722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0385 1.94088C14.3461 1.0308 15.635 1.03564 15.9357 1.94801L18.0513 8.36732C18.1524 8.6741 18.3955 8.91315 18.7039 9.00914L24.0677 10.6784C24.9379 10.9492 25.0219 12.1478 24.198 12.5373L18.5959 15.1855C18.3508 15.3014 18.1633 15.5118 18.0762 15.7686L15.933 22.0925C15.6274 22.9943 14.3539 22.9991 14.0414 22.0998L11.8413 15.7684C11.7521 15.5118 11.5624 15.3025 11.3158 15.1887L5.58102 12.5417C4.74648 12.1565 4.82993 10.9442 5.70936 10.677L11.2097 9.00569C11.5185 8.91186 11.7631 8.67476 11.8664 8.36901L14.0385 1.94088Z",
    fill: "#FDB62C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0306 1.91671C15.6999 0.913099 14.2821 0.907775 13.9438 1.90887L11.7716 8.337C11.6787 8.61217 11.4586 8.82556 11.1807 8.91L5.68029 10.5813C4.71291 10.8752 4.62112 12.2088 5.53911 12.6325L11.2739 15.2795C11.4958 15.3819 11.6666 15.5703 11.7468 15.8012L13.9469 22.1326C14.2906 23.1219 15.6916 23.1165 16.0277 22.1246L18.1709 15.8007C18.2493 15.5696 18.4181 15.3802 18.6387 15.2759L24.2407 12.6277C25.147 12.1992 25.0546 10.8808 24.0974 10.5829L18.7336 8.91365C18.456 8.82727 18.2373 8.61212 18.1463 8.33601L16.0306 1.91671Z",
    stroke: "#F7A526",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_348_8722",
    x: 0.799988,
    y: 0.0610046,
    width: 28.1707,
    height: 29.9106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.890196 0 0 0 0 0.4 0 0 0 0 0.0509804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_348_8722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_348_8722",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_348_8722"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5e27bc892d08ded764f0b77a1e14009d.svg";
export { ForwardRef as ReactComponent };